import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabPanelProps {
  setTabValueEventCallBack: any;
  label: string;
  tabs: string[];
  tab: string;
}

function TabHeaderComponent(props: TabPanelProps) {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    props.setTabValueEventCallBack(newValue);
    setTabValue(newValue);
  };

  function setTabIndex(index: number) {
    return {
      id: `${props.tab}-tab-${index}`,
      'aria-controls': `${props.tab}-tabpanel-${index}`,
    };
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label={props.label}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile>
        {props.tabs.map((tab, index) => (
          <Tab key={tab} label={tab} {...setTabIndex(index)} />
        ))}
      </Tabs>
    </Box>
  );
}

export default TabHeaderComponent;